let stationData = [
  {
    'id': 1,
    'station': '船长',
    'branch_id': 1
  },
  {
    'id': 2,
    'station': '大副',
    'branch_id': 1
  },
  {
    'id': 3,
    'station': '二副',
    'branch_id': 1
  },
  {
    'id': 4,
    'station': '三副',
    'branch_id': 1
  },
  {
    'id': 5,
    'station': '实习生',
    'branch_id': 1
  },
  {
    'id': 6,
    'station': '轮机长',
    'branch_id': 2
  },
  {
    'id': 7,
    'station': '大管轮',
    'branch_id': 2
  },
  {
    'id': 8,
    'station': '二管轮',
    'branch_id': 2
  },
  {
    'id': 9,
    'station': '三管轮',
    'branch_id': 2
  },
  {
    'id': 10,
    'station': '实习生',
    'branch_id': 2
  },
  {
    'id': 11,
    'station': '海务主管',
    'branch_id': 3
  },
  {
    'id': 12,
    'station': '机务主管',
    'branch_id': 3
  },
  {
    'id': 13,
    'station': '电机员',
    'branch_id': 2
  },
  {
    'id': 14,
    'station': '水手',
    'branch_id': 1
  },
  {
    'id': 15,
    'station': '服务生',
    'branch_id': 4
  },
  {
    'id': 16,
    'station': '大厨',
    'branch_id': 4
  },
  {
    'id': 17,
    'station': '水手长',
    'branch_id': 1
  },
  {
    'id': 18,
    'station': '机工长',
    'branch_id': 2
  },
  {
    'id': 19,
    'station': '副政委',
    'branch_id': 1
  },
  {
    'id': 20,
    'station': '值班水手',
    'branch_id': 1
  },
  {
    'id': 21,
    'station': '木匠',
    'branch_id': 1
  },
  {
    'id': 22,
    'station': '值班机工',
    'branch_id': 2
  },
  {
    'id': 23,
    'station': '保安官',
    'branch_id': 1
  },
  {
    'id': 24,
    'station': '政干',
    'branch_id': 1
  },
  {
    'id': 25,
    'station': '电子电气员',
    'branch_id': 2
  },
  {
    'id': 26,
    'station': '见习三副',
    'branch_id': 1
  },
  {
    'id': 27,
    'station': '机工',
    'branch_id': 2
  },
  {
    'id': 28,
    'station': '轮助',
    'branch_id': 1
  },
  {
    'id': 29,
    'station': '测试岗位',
    'branch_id': 1
  },
  {
    'id': 31,
    'station': '综合主管',
    'branch_id': 3
  },
  {
    'id': 32,
    'station': '安技部',
    'branch_id': 3
  }
]
export default {
  stationData
}



// WEBPACK FOOTER //
// ./src/utils/station.js